<div class="lm-list-container lmc">
    <div>
        <span><h2 class="card-title">{{title}}</h2></span>
    </div>
  <div class="main-content filterlist-content-area">
      <div soho-datagrid></div>
  </div>
</div>
